<template>
  <div>
    <header>
      <Header msg="Header" />
      <SettingsHeader msg="SettingsHeader" />
    </header>
    <main>
      <div class="userdata_edit container">
        <form @submit.prevent="submit">
          <div class="text_box">
            <input
              type="text"
              placeholder="顯示名稱(e.g., 住家/公司)"
              v-model="name"
            />
            <button type="button">
              <i class="icon-delete" v-on:click="name = ''"></i>
            </button>
          </div>
          <div class="error" v-if="!$v.name.required">請輸入地址名稱</div>
          <div class="text_box">
            <input
              type="text"
              placeholder="地址"
              ref="delivery_address"
              v-model="addrInput"
            />
            <button type="button">
              <i class="icon-delete" v-on:click="addrInput = ''"></i>
            </button>
          </div>
          <div class="error" v-if="!$v.addrInput.required">請輸入地址名稱</div>
          <div class="default">
            <input
              type="checkbox"
              name="address"
              id="add"
              v-model="defaultData"
              :checked="isDefault"
              :disabled="isDefault"
            />
            <label class="flex_center" for="add"> <i></i> 設為預設地址 </label>
          </div>
          <button
            type="submit"
            :disabled="$v.$invalid"
            :class="['save', $v.$invalid ? 'sent' : '']"
          >
            {{ addressId ? "更新常用地址" : "儲存為常用地址" }}
          </button>
        </form>
      </div>
    </main>
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src
import Header from "@/components/Header.vue";
import SettingsHeader from "@/components/SettingsHeader.vue";
import { Base64 } from "js-base64";
import apis from "@/services/apis";
import autocomplete from "autocompleter";
import { v4 as uuidv4 } from "uuid";

import { required } from "vuelidate/lib/validators";

export default {
  name: "userData",
  data() {
    return {
      addrInput: "",
      name: "",
      phone: "",
      picture: "",
      address: "",
      mainText: "",
      secondaryText: "",
      aptSuiteFloor: "",
      placeId: "",
      defaultData: "",
      isDefault: false,
      addressId: null,
      sessionToken: "",
    };
  },
  validations: {
    name: {
      required,
    },
    addrInput: {
      required,
    },
  },
  components: {
    SettingsHeader,
    Header,
  },
  computed: {
    userId() {
      return localStorage.getItem("lineUserId");
    },
    uuid() {
      let uuid = localStorage.getItem("qcsso:uuid");
      let userProfile = localStorage.getItem("lineUserProfile");
      let self = this;

      return uuid;
      // return localStorage.getItem("lineUserId");
    },
    userProfile() {
      return JSON.parse(Base64.decode(localStorage.getItem("lineUserProfile")));
    },
  },
  methods: {
    changeDefault(userId, address) {
      // 更新目前地址
      console.log("cache address " + JSON.stringify(address));
      localStorage.setItem("address", Base64.encode(JSON.stringify(address)));
    },
    setAddress(addrObj, updateName) {
      // {"id":1,"name":"住家","address":"台灣桃園市平鎮區環南路186巷23弄22之1號","placeId":"EjXlj7DngaPmoYPlnJLluILlubPpjq7ljYDnkrDljZfot68xODblt7cyM-W8hDIy5LmLMeiZnyIwEi4KFAoSCV1TmHKwI2g0EWLFb3ibWgPvEBYqFAoSCfHgqgywI2g0Ealydb_L5tzo","mainText":"環南路186巷23弄22之1號","secondaryText":"台灣桃園市平鎮區","aptSuiteFloor":null,"isDefault":0,"updatedTs":1586706812}
      if (updateName) {
        this.name = addrObj.name;
      }

      this.address = addrObj.address;
      this.placeId = addrObj.placeId;
      this.mainText = addrObj.mainText;
      this.secondaryText = addrObj.secondaryText;
      this.aptSuiteFloor = addrObj.aptSuiteFloor;
      this.isDefault = this.defaultData = addrObj.isDefault ? true : false;

      if (addrObj.mainText && addrObj.secondaryText) {
        // this.addrInput = `${
        //   addrObj.secondaryText ? addrObj.secondaryText : ""
        // }${addrObj.mainText ? addrObj.mainText : ""}${
        //   addrObj.aptSuiteFloor ? " " + addrObj.aptSuiteFloor : ""
        // }`;
        console.log("set and faile...");

        this.addrInput = `${addrObj.mainText ? addrObj.mainText : ""}${
          addrObj.aptSuiteFloor ? " " + addrObj.aptSuiteFloor : ""
        }`;
      } else if (addrObj.address) {
        this.addrInput = addrObj.address;
      }
    },
    getCacheAddress() {
      if (!localStorage.getItem("address")) return {};
      else {
        let addrObj = JSON.parse(
          Base64.decode(localStorage.getItem("address"))
        );
        if (addrObj.placeId) return addrObj;
        else return null;
      }
    },
    getAddressById(addressId) {
      console.log('get address id ');
      if (GLOBAL_ENV_SDKTYPE === 'sso') {
        return apis.getSsoUserAddressById(this.uuid, addressId);
      } else {
        return apis.getAddressById(this.userId, addressId);
      }
      
    },
    postUserAddresses() {
      let queryApi = apis.postUserAddresses;
      let uid = this.userId;
      if (GLOBAL_ENV_SDKTYPE === "sso") {
        queryApi = apis.postSsoUserAddresses;
        uid = this.uuid;
      }
      // return apis.postUserAddresses(this.userId, {
      return queryApi(uid, {
        name: this.name,
        address: this.address,
        mainText: this.mainText,
        secondaryText: this.secondaryText,
        aptSuiteFloor: this.aptSuiteFloor,
        placeId: this.placeId,
        isDefault: this.defaultData,
      });
    },
    putUserAddress() {
      let queryApi = apis.putUserAddress;
      let uid = this.userId;
      if (GLOBAL_ENV_SDKTYPE === "sso") {
        queryApi = apis.putSsoUserAddress;
        uid = this.uuid;
      }
      // return apis.putUserAddress(this.userId, this.addressId, {
      return queryApi(uid, this.addressId, {
        name: this.name,
        address: this.address,
        mainText: this.mainText,
        secondaryText: this.secondaryText,
        aptSuiteFloor: this.aptSuiteFloor,
        placeId: this.placeId,
        isDefault: this.defaultData,
      });
    },
    submit() {
      // console.log("save the addr to the user " + this.userId);
      // console.log("save the addr " + JSON.stringify(this.getCacheAddress()));
      let self = this;
      if (this.addressId) {
        // console.log('go post');

        this.putUserAddress()
          .then((response) => {
            if (self.defaultData) {
              self.changeDefault(self.userId, {
                name: self.name,
                address: self.address,
                mainText: self.mainText,
                secondaryText: self.secondaryText,
                aptSuiteFloor: self.aptSuiteFloor,
                placeId: self.placeId,
                isDefault: self.defaultData,
              });
            }
            self.$router.push({
              path: self.$router.currentRoute.meta.backTo,
              query: self.$router.currentRoute.query,
            });
          })
          .catch((e) => {
            alert(e);
          });
      } else {
        console.log("post gogo");
        this.postUserAddresses()
          .catch((e) => {
            alert(e);
          })
          .then((response) => {
            if (self.defaultData) {
              self.changeDefault(self.userId, {
                name: self.name,
                address: self.address,
                mainText: self.mainText,
                secondaryText: self.secondaryText,
                aptSuiteFloor: self.aptSuiteFloor,
                placeId: self.placeId,
                isDefault: self.defaultData,
              });
            }

            self.$router.push({
              path: self.$router.currentRoute.meta.backTo,
              query: self.$router.currentRoute.query,
            });
          });
      }
    },
  },
  mounted() {
    var input = this.$refs.delivery_address;
    this.sessionToken = uuidv4();
    let self = this;

    autocomplete({
      input: input,
      minLength: 1,
      className: "search_focus",
      preventSubmit: true,
      fetch: function(text, update) {
        console.log("fetch detect");
        $(".autocomplete.search_focus").slideDown();
        // text = text.toLowerCase();
        // var suggestions = [
        //   { label: "桃園市平鎮區", value: "Taoyuan" },
        //   { label: "中壢市環中東路", value: "Zongli" },
        //   { label: "平鎮區環南路186", value: "Pingzhen" }
        // ];
        console.log("the text " + text);
        console.log("the sessionToken " + self.sessionToken);
        apis.getPlaceAutoComplete(text, self.sessionToken).then((response) => {
          console.log("the response");
          let suggestions = [];
          if (!response || !response.results) {
            update(suggestions);
            return;
          }

          for (let i = 0; i < response.results.length; ++i) {
            suggestions.push({
              mainText: response.results[i].mainText,
              value: response.results[i].placeId,
              secondaryText: response.results[i].secondaryText,
              address: response.results[i].address,
              // group: "地址請輸入至號",
              aptSuiteFloor: response.results[i].aptSuiteFloor,
              // group: '地址請輸入至號，樓層可一同輸入'
              // group: self.$t('Street name, apt, suite, floor, etc')
            });
          }
          update(suggestions);
        });
      },
      onSelect: function(item) {
        console.log("the item " + JSON.stringify(item));
        item.placeId = item.value || item.placeId;

        self.setAddress(item);
        self.sessionToken = uuidv4();
      },
      customize: function(input, inputRect, container, maxHeight) {
        container.style.maxHeight = "50vh";
        container.style.maxWidth = "95%";
        container.style.width = "768px";
        container.style.left = "0";
        container.style.margin = "5px auto";
      },
      render: function(item, currentValue) {
        const itemElement = document.createElement("div");
        itemElement.innerHTML = `
        <p>${item.mainText}${
          item.aptSuiteFloor ? " " + item.aptSuiteFloor : ""
        }</p>
        <p>${item.secondaryText}</p>`;

        return itemElement;
      },
      renderGroup: function(groupName, currentValue) {
        var groupElement = document.createElement("div");
        // groupElement.textContent = groupName;
        groupElement.innerHTML = `<p class="label">${groupName}</p>`;
        return groupElement;
      },
    });

    this.addressId = this.$router.currentRoute.params.addressId;

    if (this.addressId) {
      // 更新
      console.log('the address id ' + this.addressId);
      this.getAddressById(this.addressId).then((addrObj) => {
        console.log("the addrObj " + JSON.stringify(addrObj));
        this.setAddress(addrObj, true);
      });

      this.addrInput = "載入中"; // 這個給空的後續autocompleter會有問題，好怪
    } else {
      // 新增
      // 取出目前暫存的地址
      let addrObj = this.getCacheAddress();

      this.setAddress(addrObj, true);
      // this.address = addrObj.formatted_address;
      // this.placeId = addrObj.placeId;
      // this.mainText = addrObj.mainText;
      // this.secondaryText = addrObj.secondaryText;
      // this.aptSuiteFloor = addrObj.aptSuiteFloor;
    }
  },
};
</script>

<style scoped>
/*.error {
  color: #ff0000;
  font-size: 14px;
  padding-bottom: 10px;
}*/
/* @import '../assets/css/theme_default.css'; */
</style>
